<!-- Polaris (fase 5.1): the contacts list while it loads, the kit's Skeleton in the shape of the rows it stands for
     (the table from md up, the compact items below), in place of the woot's spinner. The companies list
     uses it too (fase 5.5). -->
<script setup>
import { useI18n } from 'vue-i18n';
import { Skeleton } from 'dashboard/components-next/polaris/ui/skeleton';

defineProps({
  // What is loading, for assistive tech (the companies list passes its own).
  label: { type: String, default: '' },
});

const { t } = useI18n();
const ROWS = 8;
</script>

<template>
  <div
    role="status"
    :aria-label="label || t('CONTACTS_POLARIS.LIST.LOADING')"
    data-contacts-skeleton
  >
    <div
      v-for="row in ROWS"
      :key="row"
      class="flex h-[3.25rem] items-center gap-3 border-0 border-b border-solid border-polaris-border px-4"
    >
      <Skeleton class="hidden size-4 rounded-[4px] md:block" />
      <Skeleton class="size-8 shrink-0 rounded-full" />
      <div class="grid w-48 min-w-0 gap-1.5">
        <Skeleton class="h-3 w-3/4" />
        <Skeleton class="h-2.5 w-full" />
      </div>
      <Skeleton class="ms-auto hidden h-3 w-24 @lg/list:block" />
      <Skeleton class="hidden h-3 w-28 @xl/list:block" />
      <Skeleton class="hidden h-3 w-24 @2xl/list:block" />
    </div>
  </div>
</template>
